import type { IdeaScoreFieldTypes } from 'common/constants/ideaScoreFields';

export interface GenericScoreField {
  name: string;
  fields: Array<{
    fieldID: string;
    weight: number;
    type: IdeaScoreFieldTypes;
  }>;
}

const toNumericValue = (raw: unknown): number => {
  if (typeof raw === 'boolean') {
    return raw ? 1 : 0;
  }

  const value = typeof raw === 'number' ? raw : null;
  return typeof value === 'number' && Number.isFinite(value) ? value : 0;
};

/**
 * core, reusable calculation for idea score fields
 */
export function computeScoreValues({
  fieldsMap,
  scoreFields,
}: {
  fieldsMap: Record<string, unknown>;
  scoreFields: GenericScoreField[];
}): Record<string, number> {
  const result: Record<string, number> = {};

  for (const scoreField of scoreFields) {
    // ignore malformed score fields
    if (!Array.isArray(scoreField.fields) || scoreField.fields.length === 0) {
      continue;
    }

    let impact = 0;
    let cost = 0;

    for (const part of scoreField.fields) {
      const value = toNumericValue(fieldsMap[part.fieldID]);
      const weighted = part.weight * value;

      if (part.type === 'impact') {
        impact += weighted;
      } else if (part.type === 'cost') {
        cost += weighted;
      }
    }

    result[scoreField.name] = cost === 0 ? impact : impact / cost;
  }

  return result;
}
